





import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class SvgIcon extends Vue {
  @Prop({ required: true })
  public icon!: string;

  public svg: (() => Promise<any>) | null = null;

  public created(): void {
    this.iconChanged();
  }

  @Watch('icon')
  public iconChanged() {
    this.svg = () => import(`@/assets/img/icons/${this.icon}.svg`);
  }
}
